import { Spin } from 'antd';
import type { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'translations/hooks';
import { Page } from 'ui/layout';
import { useSession } from 'technical/auth/client';
import { Routes } from './constants';

export const ProtectedRoute = ({ children }: PropsWithChildren) => {
  const { t } = useTranslation();
  const { data: session, isPending } = useSession();
  const navigate = useNavigate();

  if (isPending) {
    return (
      <div className="flex items-center justify-center p-8">
        <Spin size="large" />
      </div>
    );
  }

  if (!session?.user) {
    navigate(Routes.Login);
    return;
  }

  return (
    <Page title={t('header.title')} user={session.user}>
      {children}
    </Page>
  );
};
